define('modules/editor/views/new_popup_modal',['require','exports','module','common/views/modal_view','ldsh!../templates/new_popup_modal'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/new_popup_modal"),
    triggers: {
      "click .js-continue": "continue",
      "click .js-cancel": "cancel"
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

  _.extend(module.exports, {
    show: function(variant) {
      var popup = new module.exports({model: variant}),
          defer = $.Deferred();
      popup.on("continue", _.bind(defer.reject, defer));
      popup.on("cancel", _.bind(defer.reject, defer));
      defer.always(_.bind(popup.hide, popup));
      return defer.promise();
    }
  });
});

